import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CardStaff } from "./CardStaff";
import type { CheckInType } from "./CheckInType";
import type { PersonCheckInDTOBase } from "./PersonCheckInDTOBase";
import type { PersonStaff } from "./PersonStaff";

export class PersonCheckInStaff implements PersonCheckInDTOBase {
  constructor(public readonly assignId: number, public readonly checkInTime: Date, public readonly checkInType: CheckInType, public readonly personId: PersonStaff | null, public readonly cardId: CardStaff | null, public readonly personKey: number | null, public readonly personName: string | null, public readonly cardNum: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.cardIdLoaded = this.cardId != null;
    this.cardIdCached = this.cardId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private cardIdLoaded: boolean;
  private cardIdCached: CardStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personCheckInService().getPersonCheckInStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async cardIdLazy(): Promise<CardStaff | null> {
    if (!this.cardIdLoaded) {
      this.cardIdCached = await this.cbiServiceContext!.personCheckInService().getPersonCheckInStaffCardId(this.assignId);
      this.cardIdLoaded = true;
    }
    return this.cardIdCached;
  }
}
